import createSvgIcon from '../Utils/CreateSvgIcon';

export const Amex = createSvgIcon(
  <>
    <path d="M0,0h24v24H0z" fill="transparent" stroke="#EAEAEA" strokeWidth=".5" />
    <path
      clipRule="evenodd"
      d="M4.257 9.692 2 14.302h2.702l.335-.735h.766l.335.735h2.974v-.561l.265.56h1.539l.265-.572v.573h6.185l.753-.716.704.716 3.177.006-2.264-2.298L22 9.692h-3.128l-.732.703-.682-.703h-6.73l-.577 1.19-.592-1.19H6.863v.542l-.3-.542H4.257Zm.523.655h1.317l1.497 3.126v-3.126h1.443l1.156 2.242 1.066-2.242h1.436v3.308h-.874l-.007-2.592-1.273 2.592h-.782l-1.28-2.592v2.592H6.68l-.34-.742H4.5l-.34.741h-.963l1.583-3.307Zm12.266 0h-3.552v3.306h3.497l1.128-1.096 1.086 1.096h1.136L18.69 12.01l1.65-1.663h-1.086l-1.121 1.083-1.087-1.083Zm-11.625.56-.607 1.32h1.213l-.606-1.32Zm8.95.73v-.604h2.217l.967.965-1.01.971h-2.174v-.66h1.938v-.672h-1.938Z"
      fill="#044BBC"
      fillRule="evenodd"
    />
  </>,
  'Amex',
);
